export class ExampleUsageTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        efternamn: "Fält efternamn kan inte vara tomt",
        fornamn: "Fält förnamn kan inte vara tomt",
        moreThanZero: "Värdet måste vara större än 0",
        textOnlyNumbers: "Endast numeriska tecken är tillåtna"
    };
    // eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        accept: "Accepterar",
        alder: "Ålder",
        avbryt: "Avbryt",
        datePicker: "välj datum",
        start: "Start",
        slut: "Slut",
        disabled: "Disabled input",
        efternamn: "efternamn",
        extraLangText: "Extra lång text",
        header: "Exempel på nya komponenterna",
        laggTill: "Lägg till",
        langText: "Lång text",
        multiSelector: "Multiselector",
        multiSelectorGroupBy: "Grouped Multiselector",
        namn: "namn",
        namnInfo: "Ditt tilltalsnamn",
        otherText: "Annat",
        selectorGroupTest: "Grouped selector",
        selectorTest: "Enkel selector",
        slutmanadPicker: "Välj slutmånad",
        spara: "Spara",
        stang: "Stäng",
        tab1label: "Uppgifter",
        tab2label: "Tabeller",
        tag: "Tag",
        treeSelector: "Trädselector",
        treeSelectorSingle: "Trädselector enkel"
    };
}
